// extracted by mini-css-extract-plugin
export default {"hideTooltip":"K8-z","fadeIn":"L8-z","delay":"M8-z","recommendedSizeTooltip":"N8-z"};